import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react'
import './App.css';
import Footer from './components/Footer';
import About from './components/pages/About';
import Projects from './components/pages/Product';
import Contact from './components/pages/Contact';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import PreFooterBrief from './components/PreFooterBrief';


function App() { 
  return (
    <>
    <Router>
      {/* <Navbarupper/> */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-works" element={<Projects />} />
        <Route path="/contact-us" element={<Contact />} />
      </Routes>
      <div className="tawkto">
        <TawkMessengerReact
            propertyId="64dbbce594cf5d49dc6a9385"
            widgetId="1h7t5jp54"/>
      </div>
      <a href="/#project-brief" className="floating-brief-btn" aria-label="Go to project brief form">
        <i className="bi bi-chat-dots-fill"></i>
        <span>Start Project</span>
      </a>
      <PreFooterBrief />
      <Footer />
    </Router>
    </>
  );
}

export default App;
